@if (showLoader) {
  <div class="loading-container"><app-loading></app-loading></div>
}
<div>
  <mat-drawer-container class="container">
    <mat-drawer #drawer class="sidenav new-nav" mode="side" opened="isDrawerOpen" [disableClose]="true">
      <div class="side-menu">
        @if (step === 4) {
          <div class="title-section">
            <h3>Review Room</h3>
            <span>Make sure everything looks perfect!</span>
          </div>
        } @else {
          <div class="back-section">
            <button mat-button class="nav-button" (click)="backToScootaversePage()">
              <mat-icon>keyboard_backspace</mat-icon> Exit
            </button>
          </div>
          <div class="title-section">
            @switch (step) {
              @case (0) {
                <h3>Create a New Room</h3>
                <span>Name your new room, and then select the size, music, and background.</span>
              }

              @case (1) {
                <h3>Select Room Size</h3>
                <span>Select your room size and room capacity, and the capacity will increase with the room size.</span>
              }

              @case (2) {
                <h3>Select Music</h3>
                <span>
                  Select the music that will set the tone for your room. Attendees can adjust their own volume at any
                  time.
                </span>
              }

              @case (3) {
                <h3>Select or Create Your Room Background</h3>
                <span>This is what will appear in the background of your room.</span>
              }
            }
          </div>
        }

        @if (isCreateFlow) {
          <div>
            <mat-vertical-stepper
              #stepper
              [linear]="!roomSize"
              class="custom-stepper"
              (selectionChange)="selectionChange($event)"
            >
              <ng-template matStepperIcon="edit">
                <mat-icon>check</mat-icon>
              </ng-template>
              <mat-step label="Room size" [completed]="completedFirstStep" [editable]="true"> </mat-step>
              <mat-step label="Room music" [completed]="completedSecondStep" [editable]="true"> </mat-step>
              <mat-step label="Room background" [completed]="completedLastStep" [editable]="true"> </mat-step>
              <mat-step [editable]="false" [ngStyle]="{ display: 'none' }"></mat-step>
            </mat-vertical-stepper>
          </div>
        }
      </div>
    </mat-drawer>

    <!-- Drawer Content -->
    <mat-drawer-content class="stepper-container">
      @switch (step) {
        @case (0) {
          <name-card
            [roomName]="roomName"
            (roomNameChange)="selectedName($event)"
            [isCreateFlow]="isCreateFlow"
          ></name-card>
        }

        @case (1) {
          <app-room-size-card
            [isCreateFlow]="isCreateFlow"
            [theme]="theme"
            [hasBackStepButton]="hasBackStepButton"
            [roomSize]="roomSize"
            (roomSizeChange)="selectedRoomSize($event)"
            (backStepClick)="backStep()"
            (changeStep)="changeStep($event)"
          ></app-room-size-card>
        }

        @case (2) {
          <music-card
            [selectedPlaylistId]="playlistId"
            (selectedPlaylistIdChange)="selectedMusicPlaylist($event)"
            (backStepClick)="backStep()"
            [isCreateFlow]="isCreateFlow"
            [hasBackStepButton]="hasBackStepButton"
          ></music-card>
        }

        @case (3) {
          @if (roomSize) {
            <background-card
              [selectedBackground]="theme"
              (selectedBackgroundChange)="selectedBackground($event)"
              [roomSize]="roomSize"
              (backStepClick)="backStep()"
              (unSavedChanges)="unSavedChanges = $event"
              [isCreateFlow]="isCreateFlow"
              [hasBackStepButton]="hasBackStepButton"
            ></background-card>
          }
        }

        @case (4) {
          <confirm-card
            [roomName]="roomName"
            [playlistId]="playlistId"
            [theme]="theme"
            [roomSizeInfo]="roomSize"
            [isCreateFlow]="isCreateFlow"
            (createRoom)="confirmCreateRoomResp($event)"
            (backStepClick)="backStep()"
          ></confirm-card>
        }
      }
    </mat-drawer-content>
  </mat-drawer-container>
</div>
